import React from 'react';
import {ConfigLayoutMenuApi} from "../../../services/Api/types";
import {Link} from "react-router-dom";
import {ReactComponent as ArrowRightIco} from "../../../../images/icons/arrow-right.svg";
import {useTranslation} from "react-i18next";

interface Props {
    menuLinks: ConfigLayoutMenuApi[]
}

const DrawerLinksSection = ({menuLinks}: Props) => {
    const {t} = useTranslation();
    
    const renderStoreLinkView = function (storeLink: ConfigLayoutMenuApi) {
        if (storeLink.link.includes("http") || storeLink.link.includes("www")) {
            return (
                <a className="nav-link" href={storeLink.link}>
                    <span>{storeLink.title}</span>
                    <ArrowRightIco/>
                </a>
            )
        }
        return (
            <Link className="nav-link" to={`${storeLink.link}`}>
                <span>{storeLink.title}</span>
                <ArrowRightIco/>
            </Link>
        )
    }

    return (
        <ul className="navbar-nav justify-content-end flex-grow-1">
            <h5>{t("modules.navbar.field.information.title")}</h5>
            {
                menuLinks.map((storeLink) =>
                    <li className="nav-item"
                        key={`${storeLink.title}-${storeLink.link}-${storeLink.type}`}>
                        {renderStoreLinkView(storeLink)}
                    </li>
                )
            }
        </ul>
    )
}

export default DrawerLinksSection;